import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { validateErrorIfSetWith, validateOptionalRequireIf } from '~/hooks/reactHookForm';
import { OutcomesFormProps } from '~pages/Dialler/ConnectDialler/VoiceView/OutcomeCapture';

const OutcomesForm = ({ formSubmitting }: OutcomesFormProps) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Grid item xs={12}>
        <Controller
          name='opportunity_id'
          control={control}
          defaultValue={''}
          rules={{
            validate: {
              optionalRequireIf: (value: string) => {
                const validate = validateOptionalRequireIf(value, 'lead_id', getValues);
                return validate ? true : 'Opportunity is required';
              },
              errorIfSetWith: (value: string) => {
                const validate = validateErrorIfSetWith(value, 'lead_id', getValues);
                return validate ? true : 'Cannot be set when Lead ID is set';
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='opportunity_id'
              label='Opportunity ID'
              disabled={formSubmitting}
              error={Boolean(errors.opportunity_id)}
              helperText={errors.opportunity_id?.message as string | undefined}
            />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          name='lead_id'
          control={control}
          defaultValue={''}
          rules={{
            validate: {
              optionalRequireIf: (value: string) => {
                const validate = validateOptionalRequireIf(value, 'opportunity_id', getValues);
                return validate ? true : 'Lead ID is required';
              },
              errorIfSetWith: (value: string) => {
                const validate = validateErrorIfSetWith(value, 'opportunity_id', getValues);
                return validate ? true : 'Cannot be set when Opportunity ID is set';
              },
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              variant='outlined'
              id='lead_id'
              label='Lead ID'
              disabled={formSubmitting}
              error={Boolean(errors.lead_id)}
              helperText={errors.lead_id?.message as string | undefined}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default OutcomesForm;
